import {getFinanceiroDashboard} from '../Financeiro/FinanceiroService';
import {listLicencas} from '../Licencas/LicencasService';
import {listCatalogEntity} from '../Sistemas/SistemasService';
import {listUsers} from '../Usuarios/UsersService';

export const getPortalDashboardData = async () => {
    const [users, sistemas, licencas, financeiro] = await Promise.allSettled([
        listUsers({page: 0, size: 5}),
        listCatalogEntity('sistemas', {page: 1, pageSize: 5, sortBy: 'nome', order: 'asc'}),
        listLicencas({page: 1, pageSize: 5, sortBy: 'atualizado_em', order: 'desc'}),
        getFinanceiroDashboard(),
    ]);

    return {users, sistemas, licencas, financeiro};
};
